import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React, { useContext } from 'react';
import classNames from 'classnames';
import s from './content.module.css';
import { context } from '../utils';
var Content = function Content(_ref) {
  var _classNames;
  var children = _ref.children,
    _ref$scrollable = _ref.scrollable,
    scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
    onScroll = _ref.onScroll;
  var _useContext = useContext(context),
    mobile = _useContext.mobile,
    dataTest = _useContext.dataTest;
  var ignoreScroll = scrollable ? {
    'data-scroll-lock-ignore': ''
  } : {};
  return React.createElement("div", Object.assign({
    className: classNames(s.box, (_classNames = {}, _defineProperty(_classNames, s.scrollable, scrollable), _defineProperty(_classNames, s.mobile, mobile), _classNames)),
    onScroll: onScroll,
    "data-test": dataTest && "".concat(dataTest, "-content")
  }, ignoreScroll), children);
};
export default Content;